import { render, staticRenderFns } from "./AlertInfo.vue?vue&type=template&id=12ac3f2b&scoped=true&"
import script from "./AlertInfo.vue?vue&type=script&lang=js&"
export * from "./AlertInfo.vue?vue&type=script&lang=js&"
import style0 from "./AlertInfo.vue?vue&type=style&index=0&id=12ac3f2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ac3f2b",
  null
  
)

export default component.exports